import { render, staticRenderFns } from "./autoria-seleccionados.vue?vue&type=template&id=03c8deea"
import script from "./autoria-seleccionados.vue?vue&type=script&lang=js"
export * from "./autoria-seleccionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports